/**
 * @generated SignedSource<<dcb77fb886b3fb3193222a99aaf88255>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RequestAddAttachmentInput = {
  clientMutationId?: string | null;
  contentId?: string | null;
  contentLength?: number | null;
  contentType?: string | null;
  filename: string;
};
export type imageStripAddMutation$variables = {
  input: RequestAddAttachmentInput;
};
export type imageStripAddMutation$data = {
  readonly requestAddAttachment: {
    readonly attachment: {
      readonly dimensions: {
        readonly height: number;
        readonly width: number;
      } | null;
      readonly id: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    } | null> | null;
    readonly fields: any | null;
    readonly ok: boolean;
    readonly url: string | null;
  };
};
export type imageStripAddMutation = {
  response: imageStripAddMutation$data;
  variables: imageStripAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RequestAddAttachmentPayload",
    "kind": "LinkedField",
    "name": "requestAddAttachment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fields",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Attachment",
        "kind": "LinkedField",
        "name": "attachment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ImageDimensions",
            "kind": "LinkedField",
            "name": "dimensions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "width",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "height",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "FormError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "imageStripAddMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "imageStripAddMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fd34641743868bd2f12e6750f2d1f99c",
    "id": null,
    "metadata": {},
    "name": "imageStripAddMutation",
    "operationKind": "mutation",
    "text": "mutation imageStripAddMutation(\n  $input: RequestAddAttachmentInput!\n) {\n  requestAddAttachment(input: $input) {\n    ok\n    fields\n    url\n    attachment {\n      id\n      dimensions {\n        width\n        height\n      }\n    }\n    errors {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d35098ee890c57f9fd13196deb69dd6e";

export default node;
